import type { ReactNode } from 'react';

import { Button } from '@/components/Button';

/** The three bare screens of the sign-in: waiting for Okta, signed out, and a sign-in that failed. */
export function SigningIn() {
  return (
    <div role="status" className="min-h-dvh grid place-items-center bg-bg text-body text-ink-3">
      Signing in…
    </div>
  );
}

function Card({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-dvh flex items-center justify-center bg-bg text-ink p-6">
      <div className="max-w-[520px] w-full rounded-lg border border-line bg-surface p-6">
        {children}
      </div>
    </div>
  );
}

export function SignedOut({ onSignIn }: { onSignIn: () => void }) {
  return (
    <Card>
      <p className="text-body text-ink-2">You are signed out.</p>
      <div className="mt-4">
        <Button variant="primary" onClick={onSignIn}>
          Sign in
        </Button>
      </div>
    </Card>
  );
}

export function SignInFailed({ message, onSignIn }: { message: string; onSignIn: () => void }) {
  return (
    <Card>
      <h1 className="text-heading font-medium">Sign-in failed</h1>
      <p className="mt-2 text-body text-ink-2 break-words">{message}</p>
      <div className="mt-4">
        <Button variant="primary" onClick={onSignIn}>
          Sign in again
        </Button>
      </div>
    </Card>
  );
}
